import { Route, Switch } from "react-router-dom";
import { PATH_WORK_LOGS_EDIT } from "./paths";
import { RouteEdit } from "./routes/RouteEdit";

export const WorkLogs = () => {
  return (
    <Switch>
      <Route path={PATH_WORK_LOGS_EDIT} component={RouteEdit} />
    </Switch>
  );
};
